export const IsChild = (path) => {
    if (path.includes('page/')) return '/pages'
    if (path.includes('page-item/')) return '/pages'
    if (path.includes('forms/')) return '/form'
    if (path.includes('form-elements/')) return '/form'
    if (path.includes('menu/')) return '/menu-groups'
    if (path.includes('slider/')) return '/slider-groups'
    if (path.includes('slider-content/')) return '/slider-groups'
    if (path.includes('product-showcase/')) return '/product'
}